import { twMerge } from 'tailwind-merge';

import { Avatar, AvatarFallback, AvatarImage, Icon } from '@/_components';
import { useAuthContext } from '@/_providers/auth-provider';
import { formatPhoneNumber, type PhoneNumberQuerySchema } from '@/_schemas/phone-numbers';
import { getCallableNumber } from '@/_shared';

import { phoneTypeIcon } from '../phone-number';

export function PhoneNumberLinkerPreview({
  phoneNumber,
  className,
  containerClassName,
}: {
  phoneNumber: PhoneNumberQuerySchema;
  className?: string;
  containerClassName?: string;
}) {
  const { country, number, type } = phoneNumber;
  const { user } = useAuthContext();

  return (
    <article className={twMerge('flex max-w-56 flex-1 items-center gap-1.5', containerClassName)}>
      <Avatar size="sm" className="flex items-center justify-center" transparent>
        {type ? <Icon icon={phoneTypeIcon(type)} className="size-4" /> : <div className="size-4" />}
      </Avatar>

      <Avatar size="sm" legacyBgColor>
        <AvatarImage src={country?.flag?.url} />
        <AvatarFallback name={country?.name} className="text-xs" />
      </Avatar>

      <section className={twMerge('max-w-40 flex-1 text-left', className)}>
        <a
          className="text-accent decoration-primary line-clamp-1 truncate text-sm font-normal decoration-2 hover:underline dark:text-gray-400"
          target="_blank"
          href={`tel:${getCallableNumber(phoneNumber, user)}`}
          rel="noreferrer"
        >
          {formatPhoneNumber(number, country?.calling_code, country?.phone_format).formattedNumber}
        </a>
      </section>
    </article>
  );
}
